import React, { useState, useEffect } from 'react';
import ProductsNames from './ProductsNames';
import Graph from './Graph';
import GraphKwh from './GraphKwh';
import { connect } from 'react-redux';

function ProductAccount(props) {
  //Re-selection is one title, if there is more than one product then a title is added
  const [indexTitle, setIndexTitle] = useState();
  const [componentContent, setComponentContent] = useState();

  if(!props.invoicesInfo){
    return null;
  }

  const titleProductsTable = props.isEnergy ? ['חשבונית לחיוב'] : ['השוואת חודשים'];
  const countProducts = props.invoicesInfo?.generalTab?.fitcherData?.fitcher?.length;
  const hasMultipleProducts = countProducts >= 2 && !props.isEnergy;

  if (hasMultipleProducts) titleProductsTable.unshift('המוצרים שלי');
  if (props.isEnergy) titleProductsTable.push('צריכה בקוט״ש');

  const clickTitleChangingComponent = (i) => {
    setIndexTitle(i);
    if(props.isEnergy){
      if(i == 0){
        setComponentContent('graph');
      }
      else{
        setComponentContent('graph-kwh');
      }
    }else{
      setComponentContent(i === 0 ? 'details' : 'graph' );
    }
  };

  useEffect(() => {
    if(props.isEnergy){
      setComponentContent('graph');
    }else{
      setComponentContent((countProducts >= 2 ) ? 'details' : 'graph');
    }
    setIndexTitle(0)
  }, [countProducts]);

  return (
    <div className='wrapper-product-account'>
      <div className='titles-product-account'>
        {props.detailsProducts.length > 0 && titleProductsTable.map((title, i) => (
          <div className='wrapper-titles' key={i}>
            {title &&
              <div
              className={`title ${indexTitle === i ? 'colorTitle' : ''}`}
              onClick={() => clickTitleChangingComponent(i)}
            >
              {title}
            </div>
            }
          </div>
        ))}
      </div>
      {componentContent === 'details' && <ProductsNames invoicesInfo={props.invoicesInfo}></ProductsNames>}
      {componentContent === 'graph' && <Graph invoicesInfo={props.invoicesInfo} history={props.invoicesInfo?.history}></Graph>}
      {componentContent === 'graph-kwh' && <GraphKwh invoicesInfo={props.invoicesInfo} history={props.invoicesInfo?.history}></GraphKwh>}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    invoicesInfo: state.personalAreaInvoicesPage.invoicesInfo,
    detailsProducts: state.personalAreaInvoicesPage.detailsProducts,
    isEnergy: state.personalAreaInvoicesPage.isEnergy
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ProductAccount);
